var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',_vm._l((_vm.emjoi),function(item,index){return _c('li',{key:index,staticClass:"emjoi3",on:{"click":function($event){return _vm.selectEmjoi(item.icon)}}},[_vm._v(" "+_vm._s(item.icon)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }